
import Component from 'vue-class-component';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';

@DialogFactory
@Component({
})
export default class CommentReply extends IPSDialog {
    title = '回复';

    width = '600px';

    value: ItemObject = {}

    data: ItemObject = {}

    cancelText = '取消';

    confirmText = '确定';


    getResults(): {} {
        return this.data;
    }
    mounted() {
        this.data.qiKanId = this.value.qiKanId
        this.data.replyBuyerId = this.value.buyerId
        this.data.replyBuyerName = this.value.buyerName
    }
    renderContent(h) {
        return (
            <div class="r-pa-20">
                <div class="bold font-size-20" >
                    <span v-encrypt={{ data: this.value.buyerName, type: 'name', level: 1 }}> {this.value.buyerName}
                    </span>
                </div>
                <div class="line-height-28 font-size-14">
                    <span v-encrypt={{ data: this.value.buyerPhone, type: 'phone', level: 1 }}> {this.value.buyerPhone}
                    </span>
                </div>
                <div class="r-mt-20"><span class="bold font-size-14 line-height-28">回复内容</span>
                    <el-input
                        type="textarea"
                        rows={8}
                        v-model={this.data.commentContent}
                        maxlength={300}
                        show-word-limit
                    />
                </div>
            </div>
        );
    }
}
